// components/Typography/variants.jsx
export default {
  // 52px 700, text color is defined per case
  h1: "text-[40px] md:text-[46px] lg:text-[52px] leading-tight font-bold",

  // 36px 700 text color is defined per case
  h2: "text-[28px] md:text-[32px] lg:text-[36px] leading-tight font-bold",

  // 36px 500, text color is defined per case
  h2_light: "text-[28px] md:text-[32px] lg:text-[36px] leading-tight font-medium",

  // 28px 700, text color is defined per case 
  h3: "text-[22px] md:text-[24px] lg:text-[28px] leading-tight font-bold",

  // 28px 500, text color is defined per case 
  h3_light: "text-[22px] md:text-[24px] lg:text-[28px] leading-tight font-medium",

  //22 px 700
  h4: "text-[18px] lg:text-[22px] text-text leading-tight font-bold",

  //22 px 500 (used for language badges)
  h4_light: "text-[16px] md:text-[18px] lg:text-[22px] text-text leading-tight font-medium",

  // 20px 400
  body1: "text-[16px] md:text-[17px] lg:text-[20px] text-text leading-normal font-normal",

  // 20px 400 gray
  body1_dim: "text-[16px] md:text-[17px] lg:text-[20px] text-gray_700 leading-normal font-normal",

  // 20px 500
  body1_medium: "text-[16px] md:text-[17px] lg:text-[20px] text-text leading-normal font-semibold",

  // 20px 700
  body1_accent: "text-[16px] md:text-[17px] lg:text-[20px] text-text leading-normal font-bold",

  // 20px 700, color is defined per case
  btn1: "text-[17px] lg:text-[20px] leading-tight font-bold",

  // 20px 700
  btn2: "text-[17px] lg:text-[22px] leading-tight font-bold",

  // 15px 400 text color is defined per case 
  txt1: "text-[15px] leading-tight font-normal",

  // 15px 700 text color is defined per case 
  txt1_accent: "text-[15px] leading-tight font-bold",

  // 15px 400 gray
  txt1_dim: "text-[15px] text-gray_700 leading-tight font-normal",

  // 17px 400
  menu: "text-[15px] lg:text-[17px] leading-tight font-normal text-text",

  // 17px 400 gray / primary
  breadcrumbs: "text-[16px] lg:text-[17px] leading-tight font-normal text-gray_700 hover:text-primary my-0",

  // error
  error: "text-[14px] text-red-500 leading-tight font-normal",
}
